/**
 * One source of truth for every URL the panel hits. Mirrors
 * `__frontend/app/lib/core/network/api_endpoints.dart` so the Flutter
 * app and the panel speak the same protocol.
 */

const P = '/api/v1';

export const endpoints = {
  // Auth
  loginPin: `${P}/auth/login-pin`,
  sendOtp: `${P}/auth/send-otp`,
  verifyOtp: `${P}/auth/verify-otp`,
  me: `${P}/auth/me`,
  logout: `${P}/auth/logout`,
  setPin: `${P}/auth/set-pin`,
  authSessions: `${P}/auth/sessions`,
  authRevoke: (id: number) => `${P}/auth/sessions/${id}`,

  // Bills
  bills: `${P}/bills`,
  bill: (id: number) => `${P}/bills/${id}`,
  billPdf: (id: number) => `${P}/bills/${id}/pdf`,
  billCancel: (id: number) => `${P}/bills/${id}/cancel`,
  billCollectPayment: (id: number) => `${P}/bills/${id}/collect-payment`,
  billSendWhatsApp: (id: number) => `${P}/bills/${id}/send-whatsapp`,

  // Products
  products: `${P}/products`,
  product: (id: number) => `${P}/products/${id}`,
  productBulkImport: `${P}/products/bulk-import`,
  productAiAnalyze: `${P}/products/ai-analyze`,

  // Customers
  customers: `${P}/customers`,
  customer: (id: number) => `${P}/customers/${id}`,
  customerReminder: (id: number) => `${P}/customers/${id}/send-reminder`,
  customerCollectBulk: (id: number) => `${P}/customers/${id}/collect-bulk-payment`,

  // Expenses + suppliers
  expenses: `${P}/expenses`,
  expense: (id: number) => `${P}/expenses/${id}`,
  suppliers: `${P}/suppliers`,
  supplier: (id: number) => `${P}/suppliers/${id}`,

  // Employees
  employees: `${P}/employees`,
  employee: (id: number) => `${P}/employees/${id}`,
  employeeAttendance: `${P}/employees/attendance/today`,
  employeeProcessSalary: (id: number) => `${P}/employees/${id}/process-salary`,
  employeePaySalary: (salaryId: number) => `${P}/employees/salaries/${salaryId}/pay`,

  // Stock
  stockLevels: `${P}/stock/levels`,
  stockMovements: `${P}/stock/movements`,
  stockLow: `${P}/stock/low`,
  stockAdjust: `${P}/stock/adjust`,

  // Masters
  categories: `${P}/categories`,
  category: (id: number) => `${P}/categories/${id}`,
  brands: `${P}/brands`,
  brand: (id: number) => `${P}/brands/${id}`,
  branches: `${P}/branches`,
  branch: (id: number) => `${P}/branches/${id}`,

  // Marketing
  offers: `${P}/offers`,
  offer: (id: number) => `${P}/offers/${id}`,
  campaigns: `${P}/campaigns`,
  campaign: (id: number) => `${P}/campaigns/${id}`,

  // Reports
  reportRevenue: `${P}/reports/revenue`,
  reportRevenueAnalytics: `${P}/reports/revenue-analytics`,
  reportDashboard: `${P}/reports/dashboard`,
  reportInventoryValue: `${P}/reports/inventory-value`,
  reportGst: `${P}/reports/gst`,
  reportExport: `${P}/reports/export`,

  // Deep analytics
  reportAnalyticsOverview:    `${P}/reports/analytics/overview`,
  reportAnalyticsProfitLoss:  `${P}/reports/analytics/profit-loss`,
  reportAnalyticsPaymentMix:  `${P}/reports/analytics/payment-mix`,
  reportAnalyticsCustomers:   `${P}/reports/analytics/customers`,
  reportAnalyticsProducts:    `${P}/reports/analytics/products`,
  reportAnalyticsEmployees:   `${P}/reports/analytics/employees`,
  reportAnalyticsHeatmap:     `${P}/reports/analytics/heatmap`,

  // Settings + Subscription
  settings: `${P}/settings`,
  subscription: `${P}/subscription`,
} as const;
